/**
 * Query keys domain `catalog` — kategori & daftar ujian, dua scope:
 * "me" (personal, auth) dan "public". Invalidasi massal: `catalogKeys.all`.
 */
export type CatalogScope = "me" | "public";

export const catalogKeys = {
  all: ["catalog"] as const,
  categories: (scope: CatalogScope) => [...catalogKeys.all, "categories", scope] as const,
};
